<template>
<!-- 消息 -->
  <div class="message">
    <mt-header title="消息"></mt-header>
    <!-- 消息列表 -->
    <div class="messageList">
      <!-- 系统消息 -->
      <div class="systemMsg">
        <ul>
          <li @click="openPopup('',1,'管理员')">
            <div><img src="../assets/img/message/18-1.png"></div>
            <div>
              <p>云智图 - 小云</p>
              <span>一大波需求来袭</span>
            </div>
            <!-- <div>
              <span class="time">刚刚</span><span class="msgNumber">1</span>
            </div> -->
          </li>
        </ul>
      </div>
      <!-- 发送的消息 -->
      <div class="userMsg">
        <ul>
          <li v-for="(friendsList, index) in friendsLists" :key="index" @click="openPopup(friendsList.orderProjectId,friendsList.toUserId,friendsList.toUser)">
            <div><img :src="httpUrl + friendsList.resAddr"></div>
            <div>
              <p>{{friendsList.toUser}}</p>
              <span>{{friendsList.orderProjectName}}</span>
            </div>
            <div>
              <span class="time">{{friendsList.recentlyTime | formatDate}}</span><span class="msgNumber">{{friendsList.unreadCount}}</span>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <!-- 聊天页 -->
    <mt-popup v-model="popupVisible" position="right" class="popup">
       <mt-header :title= "toUserName">
        <mt-button slot="left" icon="back" @click.native="closePopup">消息</mt-button>
      </mt-header>
      <div class="title" v-show="projectTitle">
        <div class="bgimg" :class="{'zhaomu':project.status==4,'close':project.status==5,'jinxing':project.status==7,'over':project.status==8,'hezuo':project.status==6,'pingjia':project.status==9}"></div>
        <p>项目 <span @click="projectJump(project.id)">{{project.title}}</span></p>
        <span>{{project.description}}</span>
      </div>
      <mt-loadmore :top-method="loadTop"  :bottom-all-loaded="allLoaded" :auto-fill="false" ref="loadmore">
      <div class="talkContent" ref="divmsg">
        <div :class="{'sendMsg':msgHistory.fromuser === currentUser,'receiveMsg': msgHistory.fromuser !== currentUser}" v-for="(msgHistory, index) in msgHistorys" :key="index">
           <p class="Msgtime">{{msgHistory.sendtime | formatDate}}</p>
           <div class="portrait" v-if="msgHistory.msgtype === 'IMG'"><img :src="httpUrl + msgHistory.msg"></div>
           <div class="msgContent" v-if="msgHistory.msgtype === 'TXT'"><p>{{msgHistory.msg}}</p><span class="triangle"></span></div>
        </div>
      </div>
      </mt-loadmore>
      <div class="inputPart">
        <input type="text" v-model="sendMsg" >
        <div class="btns">
          <icon name="smile-o" @click.native="showEmoji"></icon>
          <icon name="picture-o" @click.native="showPicture"></icon>
          <input id="upDataPart" type="file" multiple accept="image/*" value="上传" ref="upDataPart" @change="onFormChange($event)" enctype="multipart/form-data"/>
          <icon name="chevron-right" @click.native="showMessage"></icon>
        </div>
        <!-- <picker :emoji-size="16" :per-line="9" :include="['people']" :sheetSize="20" @click="pickEmoji" :style="{position:'absolute',left:'0',bottom:'55px'}" v-if="emojiShow"></picker>
        <emoji :emoji='currentEmoji.colons' :size="16"></emoji> -->
      </div>
    </mt-popup>
  </div>
</template>

<script>
import {formatDate} from '../assets/js/date.js'
// import { Picker, Emoji } from 'emoji-mart-vue'
import { Indicator } from 'mint-ui'
export default {
  name: 'message',
  data () {
    return {
       // 图片服务器地址
      httpUrl: '',
      friendsLists: '',
      searchCondition: {
        pageNo: '1',
        pageSize: '10'
      },
      allLoaded: false,
      scrollMode: 'auto',
      project: '',
      msgHistory: '',
      msgHistorys: [],
      websocket: null,
      currentUser: '',
      toUser: null,
      toUserName: '',
      sendMsg: '',
      sendPicture: '',
      projectTitle: true,
      popupVisible: false,
      currentEmoji: '',
      emojiShow: false
    }
  },
  mounted () {
    this.getHttpUrl()
    this.initWebSocket()
    this.STATE.state.bottomindex='btnFive'
  },
  methods: {
    loadTop: function () {
      this.more()
      this.$refs.loadmore.onTopLoaded()
    },
    // loadBottom: function () {
    //   let _this = this
    //   this.getMsgHistory(_this.toUser)
    //   this.$refs.loadmore.onBottomLoaded()
    // },
    openPopup: function (orderProjectId, toUserId, toUserName) {
      let _this = this
      _this.toUserName = '与' + toUserName + '交谈中'
      _this.toUser = toUserId
      if (orderProjectId === '') {
        _this.projectTitle = false
      } else {
        _this.projectTitle = true
      }
      this.axios({
        method: 'post',
        url: 'url/work/project/getInquirySheet',
        params: {
          id: orderProjectId
        }
      }).then(function (res) {
        _this.project = res.data
      })
      _this.getMsgHistory(toUserId)
      this.axios({
        method: 'post',
        url: 'url/notice/im/clearUnreadCount',
        params: {
          from: _this.currentUser,
          to: toUserId
        }
      })
      this.popupVisible = true
    },
    closePopup: function () {
      this.popupVisible = false
    },
    projectJump: function (projectid) {
      let _this = this
      _this.$router.push({name: 'myProjectDetail', params: { projectId: projectid }})
    },
    getMsgHistory: function (toUserId) {
      Indicator.open({
        text: '加载中...',
        spinnerType: 'fading-circle'
      })
      let _this = this
      var date = Date.parse(new Date())
      this.axios({
        method: 'get',
        url: 'url/notice/im/msgHistory',
        // timeout: 100000,
        params: {
          date: date,
          from: _this.currentUser,
          to: toUserId,
          page: 1,
          pageSize: 10,
          revert: false
        }
      }).then(function (res) {
        Indicator.close()
        _this.msgHistorys = res.data.list
        _this.boxScroll()
        console.log(_this.msgHistorys)
      })
    },
    more: function () {
      Indicator.open({
        text: '加载中...',
        spinnerType: 'fading-circle'
      })
      let _this = this
      var date = Date.parse(new Date())
      this.searchCondition.pageNo = parseInt(this.searchCondition.pageNo) + 1
      this.axios({
        method: 'get',
        url: 'url/notice/im/msgHistory',
        params: {
          date: date,
          from: _this.currentUser,
          to: _this.toUser,
          page: this.searchCondition.pageNo,
          pageSize: 10,
          revert: false
        }
      }).then(function (res) {
        Indicator.close()
        _this.msgHistorys = res.data.list.concat(_this.msgHistorys)
        // if (_this.msgHistorys.length !== 8) {
        //   _this.allLoaded = true
        // }
      }).catch(function (response) {
        Indicator.close()
      })
    },
    pickEmoji: function (emoji) {
      this.currentEmoji = emoji
      this.emojiShow = false
    },
    showEmoji: function () {
      this.emojiShow = true
    },
    showMessage: function () {
      let _this = this
      this.msgHandlingSend(_this.sendMsg, 'TXT')
    },
    showPicture: function () {
      this.$refs.upDataPart.click()
    },
    onFormChange: function (e) {
      let _this = this
      let file = e.target.files[0]
      let param = new FormData()
      param.append('file', file)
      this.axios({
        method: 'post',
        url: '/url/common/uploadImg',
        timeout: 100000,
        data: param
      }).then(function (response) {
        console.log(response.data.data)
        _this.sendPicture = response.data.data.resaddr
        _this.msgHandlingSend(_this.sendPicture, 'IMG')
      })
    },
    getHttpUrl: function () {
      let _this = this
      this.axios.get('url/user/imgHttpUrl.json')
      .then(function (res) {
        _this.httpUrl = res.data
      })
    },
    initWebSocket: function () {
      let _this = this
      this.currentUser = _this.STATE.state.loginId
      if ('WebSocket' in window) {
        // this.websocket = new WebSocket('ws://localhost:8130/webSocketServer')
        this.websocket = new WebSocket('ws://172.16.0.121:8130/webSocketServer')
        // websocket = new WebSocket("ws://im.yunzhitu.com/");
      } else {
        alert('服务器不支持websocket')
        return
      }
      this.websocket.onopen = function () {
        console.log('Info: connection opened.')
        _this.getFriendsList()
      }
      this.websocket.onmessage = function (event) {
        console.log(event)
        console.log('Received: ' + event.data)
        var data = JSON.parse(event.data)
        var paramb = {}
        paramb.chattype = data.type
        paramb.fromuser = data.from
        paramb.msg = data.msg
        paramb.msgtype = data.msgType
        paramb.sendtime = data.time
        paramb.touser = data.to
        _this.msgHistorys.push(paramb)
        console.log(_this.msgHistorys)
        _this.boxScroll()
      }
      this.websocket.onclose = function (event) {
        console.log('Info: connection closed.')
        console.log(event)
      }
    },
    getFriendsList: function () {
      let _this = this
      this.axios({
        method: 'post',
        url: 'url/notice/im/getContactList',
        params: {
          accountId: _this.currentUser
        }
      }).then(function (res) {
        _this.friendsLists = res.data
        console.log(_this.friendsLists)
      })
    },
    msgHandlingSend: function (msg, msgType) {
      let _this = this
      // var groupindex = toUser.indexOf("g_");
      var charType = 'chat'
      var toUserId = _this.toUser // 联系人ID
      var currentUser = _this.currentUser.toString()
      // if(groupindex>=0){
      //     toUserId = toUser.substr(2);
      //     charType = 'groupchat';
      // }
      // var toUserType = $("#toUserType").val();//联系人身份
      // if(toUserId == null || toUserId == ""){
      //     ws.error("请选择联系人");
      //     IM.textSending = false;
      //     return;
      // }
      if (msg === null || msg.length === 0) {
        return
      }
      if (toUserId === null) {
        return
      }
      var options = {
        from: currentUser,
        to: toUserId, // 接收人
        msg: msg, // 消息内容
        type: charType, // 消息类型
        msgType: msgType
      }
      this.websocket.send(JSON.stringify(options))
      _this.sendMsg = ''
      var msgOptions = {}
      msgOptions.chattype = charType
      msgOptions.fromuser = _this.currentUser
      msgOptions.msg = msg
      msgOptions.msgtype = msgType
      msgOptions.sendtime = new Date()
      msgOptions.touser = toUserId
      _this.msgHistorys.push(msgOptions)
      _this.boxScroll()
    },
    boxScroll: function () {
      let _this = this
      setTimeout(function () {
        _this.$refs.divmsg.scrollTop = _this.$refs.divmsg.scrollHeight
        console.log(_this.$refs.divmsg.scrollTop)
      }, 50)
    }
  },
  // components: {
  //   Picker,
  //   Emoji
  // },
  filters: {
    formatDate (time) {
      var date = new Date(time)
      return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
    }
  }
}
</script>

<style scoped>
.messageList{
  background-color: #f0eff5;
}
.systemMsg{
  margin-bottom:6px;
}
.userMsg{
  border-top: 1px solid #ccc;
  margin-bottom: 70px;
}
li{
  background-color: #fff;
  width: 100%; 
  padding: 7px 20px;
  border-bottom: 1px solid #ccc;
  box-sizing: border-box;
}
li div{
  display: inline-block;
  vertical-align: middle;
}
li div:nth-child(1){
  width: 20%;
}
li div:nth-child(1) img{
  width: 48px;
  height: 48px;
  border-radius:50%;
  -webkit-border-radius:50%;
  -moz-border-radius:50%;
}
li div:nth-child(2){
  width: 45%;
}
li div:nth-child(2) p{
  font-size: 14px;
}
li div:nth-child(2) span{
  display: block;
  font-size: 12px;
  color: #8a8a8a;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
li div:nth-child(3){
  width: 30%;
  text-align: right;
}
li div:nth-child(3) .time{
  font-size: 10px;
  color: #bababa;
}
li div:nth-child(3) .msgNumber{
  font-size: 12px;
  display: inline-block;
  width: 25px;
  height: 25px;
  text-align: center;
  line-height: 25px;
  background-color: #ff6700;
  color: #fff;
  border-radius:50%;
  -webkit-border-radius:50%;
  -moz-border-radius:50%;
  margin-left: 5px;
}
.popup{
  width: 100%;
  height: 100%;
}
.title{
  padding:10px 19px;
  box-shadow: 0 2px 2px 2px #b5b5b5;
}
.title img{
  width: 40px;
  float: right;
  margin-top:-10px;
  margin-right: -19px;

}
.title p{
  font-size: 14px;
}
.title p span{
  font-size: 14px;
  color: #199fd9;
}
.title span{
  font-size: 10px;
  color: #8a8a8a;
}
.talkContent{
  overflow: auto;
  padding: 7px 15px;
  height: 70vh;
}
@media screen and (max-width: 320px){
  .talkContent{
  height: 65vh;
}

}
.receiveMsg,.sendMsg{
  overflow: hidden;
  margin-bottom: 20px;
}
.receiveMsg .portrait,.receiveMsg .msgContent{
  float: left;
}
.sendMsg .portrait,.sendMsg .msgContent{
  float: right;
}
.portrait{
  width: 39px;
  height: 39px;
}
.portrait img{
  width: 100%;
  height: 100%;
  border-radius:50%;
  -webkit-border-radius:50%;
  -moz-border-radius:50%;
}
.msgContent{
  font-size: 10px;
  margin-top: 20px;
  padding:5px 13px;
  box-sizing: border-box;
  max-width: 80%;
  position: relative;
}
.msgContent p{
  word-wrap: break-word;
}
.receiveMsg .msgContent{
  margin-left: 10px;
  border-radius:0 5px 5px 5px;
  -webkit-border-radius:0 5px 5px 5px;
  -moz-border-radius:0 5px 5px 5px;
  background-color: #d2d2d2;
  color: #000
}
.receiveMsg .msgContent .triangle{
  position: absolute;
  top: 0;
  left: -5px;
  width: 0;
  height: 0;
  border-top: 6px solid #d2d2d2;
  border-left: 6px solid transparent; 
}
.sendMsg .msgContent{
  margin-right: 10px;
  border-radius:5px 0 5px 5px;
  -webkit-border-radius:5px 0 5px 5px;
  -moz-border-radius:5px 0 5px 5px;
  background-color: #108ee9;
  color: #fff;
}
.sendMsg .msgContent .triangle{
  position: absolute;
  top: 0;
  right: -5px;
  width: 0;
  height: 0;
  border-top: 6px solid #108ee9;
  border-right: 6px solid transparent;
}
.msgContent img{
  max-width: 150px;
  max-height: 150px;
  width: auto;
  height: auto;
  margin-top: 5px;
}
.Msgtime{
  margin: 0 auto 5px;
  width: 170px;
  text-align: center;
  background-color: #d2d2d2;
  color: #fff;
  border-radius:5px;
  -webkit-border-radius:5px;
  -moz-border-radius:5px;
  font-size: 9px;
}
.inputPart{
  display: table;
  width: 100%;
  height: 50px;
  line-height: 50px;
  background:#f4f4f5;
  position: fixed;
  bottom:0px;
  padding-left: 10px;
  box-sizing: border-box;
}
.inputPart input{
  display: table-cell;
  width: 95%;
  border:1px solid #e1e1e1;
  border-radius:15px;
  -webkit-border-radius:15px;
  -moz-border-radius:15px;
  padding:5px 10px;
  box-sizing: border-box;
  font-size: 14px;
  outline: none;
}
.inputPart .btns{
  display: table-cell;
  width:100px;
  text-align: center
}
.inputPart .btns .fa-icon{
  transform: scale(1.5);
  margin: 0 7px;
}
.popup .zhaomu{
  backgro44pxund-image:url('../assets/img/main_app/state-4.png');
}
.popup .close{
  background-image:url('../assets/img/main_app/state-5.png');
}
.popup .jinxing{
  background-image:url('../assets/img/main_app/state-7.png');
}
.popup .over{
  background-image:url('../assets/img/main_app/state-8.png');
}
.popup .hezuo{
  background-image:url('../assets/img/main_app/state-6.png');
}
.popup .pingjia{
  background-image:url('../assets/img/main_app/state-9.png');
}
.bgimg{
  width:44px;
  height: 44px;
  float: right;
  background-size: 100% 100%;
}
#upDataPart{
  display:none;
}
</style>



// WEBPACK FOOTER //
// message.vue?c088c262